import styled, { css } from "styled-components";
import { Atom } from 'AppReact'

const template = styled.div`
  ${({ theme, displayState }) => css`
    font-size: 12px;
    line-height: 23px;
    letter-spacing: 1px;
    color: ${displayState?.selected ? theme?.colour?.primary : '#9EACB0'};
    text-underline-offset: 3px;
    
    cursor: pointer;

    text-decoration: ${displayState?.selected ? 'underline' : 'none'};

    &:hover {
      color: ${theme?.colour?.primary};
      text-decoration: underline;
    }
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template });